import { render, staticRenderFns } from "./cookies.vue?vue&type=template&id=2d370611&"
import script from "./cookies.vue?vue&type=script&lang=ts&"
export * from "./cookies.vue?vue&type=script&lang=ts&"
import style0 from "./cookies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AnimateFade: require('/Users/markussh/git/theodora-tech-website/src/components/animate/AnimateFade.vue').default})
